<template>
  <div class="m-t-10 m-b-10 p-20 bor-ccc pos-rel">
    <div class="tit">{{ title }}</div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default() {
          return ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// formBlock.vue?42f02728